export class ComponentChanged {
    constructor(type,gCV,gOV,sOV,iE) {
        this.type= type;
        this.getCurrentValue = gCV;
        this.getOriginalValue = gOV;
        this.setOriginalValue = sOV;
        this.isEqual = iE;
    }   
    type:string;     
    getCurrentValue: () => any;    
    getOriginalValue: () => any;
    setOriginalValue: (value) => any;
    isEqual: () => boolean;
}